import React, { useState } from "react";
import { QuizHeader, gridCols } from "./shared";

const MultiSelectStep = ({ step, prevStep, onAnswer, stepLabel }) => {
  const [selected, setSelected] = useState([]);

  const toggle = (opt) => {
    // "None" is exclusive: picking it clears everything else
    if (opt.name === "None") {
      setSelected(["None"]);
      return;
    }
    setSelected((prev) => {
      const withoutNone = prev.filter((n) => n !== "None");
      return withoutNone.includes(opt.name)
        ? withoutNone.filter((n) => n !== opt.name)
        : [...withoutNone, opt.name];
    });
  };

  return (
    <section className="qz-step">
      <QuizHeader
        title={step.question}
        subtitle={step.subtitle || "Select all that apply"}
        stepLabel={stepLabel}
        onBack={prevStep}
      />

      <div
        className="qz-grid qz-grid--fit qz-grid--options"
        style={{ "--qz-cols": gridCols(step.options.length) }}
      >
        {step.options.map((opt) => {
          const isOn = selected.includes(opt.name);
          return (
            <button
              key={opt.name}
              type="button"
              aria-pressed={isOn}
              className={`qz-option ${isOn ? "is-selected" : ""}`}
              onClick={() => toggle(opt)}
            >
              <span className="qz-option__mark" aria-hidden="true" />
              <span className="qz-option__text">
                <span className="qz-option__name">{opt.name}</span>
              </span>
            </button>
          );
        })}
      </div>

      <div className="qz-actions">
        <button
          type="button"
          className="qz-btn qz-btn--primary"
          disabled={selected.length === 0}
          onClick={() => onAnswer(selected)}
        >
          Continue
        </button>
      </div>
    </section>
  );
};

export default MultiSelectStep;